/**
 * @params {Number} targetY - 滚动目标Y坐标值,不传默认滚动到顶部
 */

const scrollAnimation = targetY => {
  window.scrollTo({
    top: targetY || 0,
    behavior: 'smooth',
  });
  // let currentY = document.documentElement.scrollTop || document.body.scrollTop;

  // const scrollHeight =
  //   document.documentElement.scrollHeight || document.body.scrollHeight;
  // const clientHeight =
  //   document.documentElement.clientHeight || document.body.clientHeight;
  // let isEnd = false;
  // if (scrollHeight - currentY === clientHeight && targetY >= 1) {
  //   // console.log('到达底部');
  //   isEnd = true;
  // }
  // // 计算需要移动的距离
  // const needScrollNum = (targetY || 0) - currentY;
  // setTimeout(() => {
  //   // 一次调用滑动帧数，每次调用值不同
  //   const dist = Math.ceil(needScrollNum / 10);
  //   currentY += dist;
  //   window.scrollTo(0, currentY);
  //   // 如果移动幅度小于10px，直接移动，否则递归调用，实现动画效果
  //   if (needScrollNum > 10 || needScrollNum < -10) {
  //     if (isEnd) {
  //       return;
  //     }
  //     scrollAnimation(targetY || 0);
  //   } else {
  //     window.scrollTo(0, targetY);
  //   }
  // }, 1);
};

export default scrollAnimation;
